import { AnimatePresence, motion } from 'motion/react';
import { useId } from 'react';
import { Button } from '../../../shared/components/button';
import { Field, fieldDescribedBy } from '../../../shared/components/field';
import { INPUT_CLASS } from '../../../shared/constants/form.constant';
import { useDialogFocus } from '../../../shared/hooks/use-dialog-focus';
import { useCreateLedger } from '../hooks/use-create-ledger';

interface NewLedgerDialogProps {
  readonly open: boolean;
  readonly onClose: () => void;
}

export function NewLedgerDialog({ open, onClose }: NewLedgerDialogProps) {
  const ref = useDialogFocus(open, onClose);
  const titleId = useId();
  const { name, changeName, submit, error, isCreating } = useCreateLedger(onClose);

  return (
    <AnimatePresence>
      {open ? (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          <motion.div
            aria-hidden="true"
            className="absolute inset-0 bg-ink/40"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
          />
          <motion.div
            ref={ref}
            role="dialog"
            aria-modal="true"
            aria-labelledby={titleId}
            initial={{ opacity: 0, scale: 0.97 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.97 }}
            transition={{ duration: 0.16 }}
            className="relative w-full max-w-sm rounded-card bg-card p-6 shadow-lift"
          >
            <h2 id={titleId} className="font-display text-lg text-ink">
              Tally baru
            </h2>
            <p className="mt-1 text-sm text-muted">Buku kas terpisah, misalnya untuk arisan atau kas kontrakan. Kamu jadi Owner-nya.</p>
            <form onSubmit={submit} noValidate className="mt-5 flex flex-col gap-4">
              <Field id="new-ledger-name" label="Nama Tally" error={error ?? undefined}>
                <input
                  id="new-ledger-name"
                  data-autofocus
                  value={name}
                  maxLength={60}
                  onChange={(e) => changeName(e.target.value)}
                  placeholder="Kas Arisan"
                  aria-invalid={error ? true : undefined}
                  aria-describedby={fieldDescribedBy('new-ledger-name', false, error ?? undefined)}
                  className={INPUT_CLASS}
                />
              </Field>
              <div className="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
                <Button onClick={onClose}>Batal</Button>
                <Button type="submit" variant="primary" disabled={isCreating}>
                  {isCreating ? 'Membuat...' : 'Buat dan buka'}
                </Button>
              </div>
            </form>
          </motion.div>
        </div>
      ) : null}
    </AnimatePresence>
  );
}
